import { defineStore } from 'pinia';

interface UserState {
  id: string;
  name: string;
  avatar: string;
  token: string;
  isLoggedIn: boolean;
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    id: '',
    name: '',
    avatar: '',
    token: '',
    isLoggedIn: false,
  }),
  
  getters: {
    userInfo: (state) => ({
      id: state.id,
      name: state.name,
      avatar: state.avatar,
    }),
    hasLogin: (state) => state.isLoggedIn,
  },
  
  actions: {
    setUserInfo(userInfo: Partial<UserState>) {
      if (userInfo.id) this.id = userInfo.id;
      if (userInfo.name) this.name = userInfo.name;
      if (userInfo.avatar) this.avatar = userInfo.avatar;
      if (userInfo.token) {
        this.token = userInfo.token;
        this.isLoggedIn = true;
        // 保存token到localStorage
        localStorage.setItem('token', userInfo.token);
      }
    },
    
    logout() {
      this.id = '';
      this.name = '';
      this.avatar = '';
      this.token = '';
      this.isLoggedIn = false;
      // 清除localStorage中的token
      localStorage.removeItem('token');
    },
    
    // 从localStorage恢复用户状态
    restoreUserState() {
      const token = localStorage.getItem('token');
      if (token) {
        this.token = token;
        this.isLoggedIn = true;
        // 可以在这里调用API获取用户信息
        // this.fetchUserInfo();
      }
    },
    
    // 调用API获取用户信息
    // async fetchUserInfo() {
    //   try {
    //     const response = await http.get('/user/info');
    //     if (response.code === 0) {
    //       this.setUserInfo(response.data);
    //     }
    //   } catch (error) {
    //     console.error('获取用户信息失败', error);
    //   }
    // },
  },
}); 